/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../common";
import type {
  XyoWorldGeotokens,
  XyoWorldGeotokensInterface,
} from "../XyoWorldGeotokens";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "_name",
        type: "string",
      },
      {
        internalType: "string",
        name: "_symbol",
        type: "string",
      },
      {
        internalType: "string",
        name: "baseURI",
        type: "string",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "slot",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "DataSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "by",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "slot",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "DataSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "balance",
        type: "uint256",
      },
    ],
    name: "Erc20Deposited",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "balance",
        type: "uint256",
      },
    ],
    name: "Erc20Withdrew",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "contract IERC721",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Erc721Deposited",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "contract IERC721",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Erc721Withdrew",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "Minted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "newMinter",
        type: "address",
      },
    ],
    name: "MinterSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "SafeMinted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
    ],
    name: "_balanceErc20",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenOfOwnerByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "parentOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "isOwner",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "exists",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "isMinter",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newMinter",
        type: "address",
      },
    ],
    name: "setMinter",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "minter",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "mint",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "safeMint",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "slot",
        type: "uint256",
      },
    ],
    name: "data",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "slot",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "setData",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "withdrawErc20",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "depositErc20",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
    ],
    name: "balanceErc20",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "contract IERC721",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "depositErc721",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "contract IERC721",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "withdrawErc721",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "contract IERC721",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "containsErc721",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "locked",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type XyoWorldGeotokensConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: XyoWorldGeotokensConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class XyoWorldGeotokens__factory extends ContractFactory {
  constructor(...args: XyoWorldGeotokensConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    _name: PromiseOrValue<string>,
    _symbol: PromiseOrValue<string>,
    baseURI: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<XyoWorldGeotokens> {
    return super.deploy(
      _name,
      _symbol,
      baseURI,
      overrides || {}
    ) as Promise<XyoWorldGeotokens>;
  }
  override getDeployTransaction(
    _name: PromiseOrValue<string>,
    _symbol: PromiseOrValue<string>,
    baseURI: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_name, _symbol, baseURI, overrides || {});
  }
  override attach(address: string): XyoWorldGeotokens {
    return super.attach(address) as XyoWorldGeotokens;
  }
  override connect(signer: Signer): XyoWorldGeotokens__factory {
    return super.connect(signer) as XyoWorldGeotokens__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): XyoWorldGeotokensInterface {
    return new utils.Interface(_abi) as XyoWorldGeotokensInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): XyoWorldGeotokens {
    return new Contract(address, _abi, signerOrProvider) as XyoWorldGeotokens;
  }
}
